import { CategoricalStrategy } from "../../../../lib/layers/selectable/color/strategies";
export class SingleColorStrategy extends CategoricalStrategy {
    constructor() {
        super();
        this.name = 'Single';
        this.visible_inputs = () => [...super.visible_inputs(), 'colorize-startcolor'];
    }
    colors() { return []; }
    generate_colors(color_range) {
        color_range.update_jenks([color_range.start]);
        return [color_range.start];
    }
}
